import { writable } from 'svelte/store';

export const DEV_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjMiLCJsb2dpbiI6IkFub255bW91cyBLZXkiLCJyb2xlIjoiYW5vbnltb3VzIiwiaXNzIjoiaHR0cHM6XC9cL21hcmlhZ2UtcGFyZmFpdC5jb20iLCJleHAiOjE2Mjc5MjI0Njh9.p1l9w-CmM58TBeltZMeNMaREMSwPNFCxgslejFGpK0k";
export const api_token = writable(undefined);
export let token;

const unsubscribe = api_token.subscribe(value => {
	console.log("new token:", value);
	token = value;
});

//const base = 'https://mariage-parfait.com/api';
const base = window.location.hostname === 'localhost' ? 'http://localhost/api' : 'https://mariage-parfait.com/api';

function send({ method, path, data, token }) {
	//const fetch = process.browser ? window.fetch : require('node-fetch').default;

	//const opts = { method, headers: {}, credentials: 'same-origin' };
	const opts = { method, headers: {}, credentials: 'include' };

	opts.headers['Content-Type'] = 'application/json';

	if (data) {
		opts.body = JSON.stringify(data);
	}

	if (token) {
		opts.headers['Authorization'] = `Bearer ${token}`;
	}

	return fetch(`${base}/${path}`, opts)
		.then(r => {
			if (r.ok) {
				return r.text();
			} else {
				return r.json().then(e => {
					const err = new Error(`${r.status} - ${e.status} ${e.message}`);
					err.login = e.login;
					err.token = e.token;
					throw err;
				});
			}
		}).then(json => {
			try {
				return JSON.parse(json);
			} catch (err) {
				return json;
			}
		});
}

export function get(path, token) {
	return send({ method: 'GET', path, token });
}

export function del(path, data, token) {
	return send({ method: 'DELETE', path, data, token });
}

export function post(path, data, token) {
	return send({ method: 'POST', path, data, token });
}

export function put(path, data, token) {
	return send({ method: 'PUT', path, data, token });
}

export async function auth(api_key) {
	return await post('auth/', { api_key: api_key });
}

export function getCookie() {
	document.cookie.split(';').forEach(function (el) {
		console.log(el);
	});
	return document.cookie.replace(/(?:(?:^|.*;\s*)API_TOKEN\s*\=\s*([^;]*).*$)|^.*$/, "$1");
}

export function getCookieWedding() {
	document.cookie.split(';').forEach(function (el) {
		console.log(el);
	});
	return document.cookie.replace(/(?:(?:^|.*;\s*)WEDDING_ID\s*\=\s*([^;]*).*$)|^.*$/, "$1");
}